import { DISCOUNTING_PARTNER, LOGISTICS_HANDLER_TYPES, strings } from '@constants'

export const logisticsHandlerTypes = Object.entries(LOGISTICS_HANDLER_TYPES).map(([key, value]) => ({ key, label: value }))
export const discountingPartnerTypes = Object.entries(DISCOUNTING_PARTNER).map(([key, value]) => ({ key, label: value }))

export const pricingTypes = [
	{ key: 'FIXED', label: 'FIXED' },
	{ key: 'MCX', label: 'MCX' },
]

export const booltypes = [
	{ key: 1, label: 'TRUE', value: true },
	{ key: 2, label: 'FALSE', value: false },
]

export const deriveFormState = (data, viewOnly = false) => {
	const _state = {
		cm_per_mt: {
			id: 'cost-per-mt',
			label: strings(['cm', 'per', 'mt']),
			placeholder: strings(['enter', 'cm', 'per', 'mt']),
			value: '',
			dirty: false,
			required: true,
			disabled: viewOnly,
		},
		marketing_expense: {
			id: 'marketing-expense',
			label: strings(['marketing_expense', 'per', 'mt']),
			placeholder: strings(['enter', 'marketing_expense', 'per', 'mt']),
			value: '',
			dirty: false,
			required: true,
			disabled: viewOnly,
		},
		net_margin_per_mt: {
			id: 'net-margin-per-mt',
			label: strings('net_margin'),
			placeholder: strings(['enter', 'net_margin']),
			value: '',
			dirty: false,
			required: false,
			disabled: viewOnly,
		},
		freight_per_mt: {
			id: 'freight-per-mt',
			label: strings(['freight', 'per', 'mt']),
			placeholder: strings(['enter', 'freight', 'per', 'mt']),
			value: '',
			dirty: false,
			required: false,
			disabled: viewOnly,
		},
		logistics_handler: {
			id: 'logistic-handler',
			label: strings('logistics', 'handler'),
			placeholder: strings(['enter', 'logistics', 'handler']),
			value: '',
			dirty: false,
			data: logisticsHandlerTypes,
			primaryKey: 'key',
			displayKey: 'label',
			required: false,
			disabled: viewOnly,
		},
		po_date: {
			id: 'pod-date',
			label: strings('po', 'date'),
			value: new Date(),
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		expected_delivery_date: {
			id: 'expected-delivery-date',
			label: strings(['expected', 'delivery', 'date']),
			value: null,
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		make_to_order: {
			id: 'make-to-order',
			label: strings(['make', 'to', 'order']),
			dirty: false,
			value: false,
			disabled: viewOnly,
		},
		management_approval: {
			value: '',
			required: false,
			dirty: false,
			disabled: viewOnly,
		},
		po: {
			value: '',
			required: false,
			dirty: false,
			disabled: viewOnly,
		},
		discounting_partner: {
			value: '',
			label: strings('discounting_partner'),
			placeholder: strings('select', 'discounting_partner'),
			primaryKey: 'key',
			displayKey: 'label',
			required: false,
			dirty: false,
			disabled: viewOnly,
		},
		original_po_number: {
			id: 'po-number',
			label: strings('po', 'number'),
			value: '',
			placeholder: strings(['enter', 'buyer', 'po', 'number']),
			dirty: false,
			disabled: viewOnly,
		},

		supplier_price: {
			id: 'supplier-price',
			label: strings('supplier_price'),
			placeholder: strings('select', 'supplier_price'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		purchase_price: {
			id: 'purchase-price',
			label: strings('purchase_price'),
			placeholder: strings('enter', 'purchase_price'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		customer_price: {
			id: 'customer-price',
			label: strings('customer_price'),
			placeholder: strings('select', 'customer_price'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		selling_price: {
			id: 'selling-price',
			label: strings('selling_price'),
			placeholder: strings('enter', 'selling_price'),
			value: '',
			dirty: '',
			disabled: viewOnly,
			required: false,
		},
		quantity_discount_dn_cn: {
			id: 'quantity-discount-dn-cn',
			label: strings('quantity_discount_dn_cn'),
			placeholder: strings('enter', 'quantity_discount_dn_cn'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		pricing_dn_cn: {
			id: 'pricing-dn-cn',
			label: strings('pricing_dn_cn'),
			placeholder: strings('enter', 'pricing_dn_cn'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		warehousing_cost: {
			id: 'warehousing-cost',
			label: strings('warehousing_cost'),
			placeholder: strings('enter', 'warehousing_cost'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		warehousing_provider: {
			id: 'warehousing-provider',
			label: strings('warehousing_provider'),
			placeholder: strings('enter', 'warehousing_provider'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		cha_cost: {
			id: 'cha-cost',
			label: strings('cha_cost'),
			placeholder: strings('enter', 'cha_cost'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		duty: {
			id: 'duty',
			label: strings('duty'),
			placeholder: strings('enter', 'duty'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		cfs: {
			id: 'cfs',
			label: strings('cfs'),
			placeholder: strings('enter', 'cfs'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		hedging_brokerage_cost: {
			id: 'hedging-brokerage-cost',
			label: strings('hedging_brokerage_cost'),
			placeholder: strings('enter', 'hedging_brokerage_cost'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		hedging_profit_and_loss: {
			id: 'hedging-profit-and-loss',
			label: strings('hedging_profit_and_loss'),
			placeholder: strings('enter', 'hedging_profit_and_loss'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		interest_deductions: {
			id: 'interest-deductions',
			label: strings('interest_deductions'),
			placeholder: strings('enter', 'interest_deductions'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
		dispatch_start_date: {
			id: 'dispatch-start-date',
			label: strings('dispatch_start_date'),
			placeholder: strings('enter', 'dispatch_start_date'),
			value: '',
			dirty: false,
			disabled: viewOnly,
			required: false,
		},
	}

	if (data?.cost_metrics) {
		_state.cm_per_mt.value = data?.cost_metrics?.cm_per_mt
		_state.cm_per_mt.dirty = true

		_state.marketing_expense.value = data?.cost_metrics?.marketing_expense
		_state.marketing_expense.dirty = true

		_state.net_margin_per_mt.value = data?.cost_metrics?.net_margin_per_mt
		_state.net_margin_per_mt.dirty = true

		if (data?.cost_metrics?.freight_per_mt !== null) {
			_state.freight_per_mt.value = data?.cost_metrics?.freight_per_mt
			_state.freight_per_mt.dirty = true
		}

		if (data?.cost_metrics?.logistics_handler !== null) {
			_state.logistics_handler.value = data?.cost_metrics?.logistics_handler
			_state.logistics_handler.dirty = true
		}

		if (data?.cost_metrics?.expected_delivery_date !== null) {
			_state.expected_delivery_date.value = data?.cost_metrics?.expected_delivery_date
			_state.expected_delivery_date.dirty = true
		}

		if (data?.cost_metrics?.dispatch_start_date !== null) {
			_state.dispatch_start_date.value = data?.cost_metrics?.dispatch_start_date
		}

		if (data?.cost_metrics?.po_date !== null) {
			_state.po_date.value = data?.cost_metrics?.po_date
			_state.po_date.dirty = true
		}

		if (data?.cost_metrics?.make_to_order !== null) {
			_state.make_to_order.value = data?.cost_metrics?.make_to_order
			_state.make_to_order.dirty = true
		}

		if (data?.cost_metrics?.management_approval !== null) {
			_state.management_approval.value = data?.cost_metrics?.management_approval
			_state.management_approval.dirty = true
		}

		if (data?.cost_metrics?.discounting_partner !== null) {
			_state.discounting_partner.value = data?.cost_metrics?.discounting_partner
			_state.discounting_partner.dirty = true
		}

		if (data?.cost_metrics?.po !== null) {
			_state.po.value = data?.cost_metrics?.po
			_state.po.dirty = true
		}

		if (data?.cost_metrics?.original_po_number !== null) {
			_state.original_po_number.value = data?.cost_metrics?.original_po_number
			_state.original_po_number.dirty = true
		}

		if (data?.cost_metrics?.supplier_price !== null) {
			_state.supplier_price.value = data?.cost_metrics?.supplier_price
			_state.supplier_price.dirty = true
		}

		if (data?.cost_metrics?.purchase_price !== null) {
			_state.purchase_price.value = data?.cost_metrics?.purchase_price
			_state.purchase_price.dirty = true
		}

		if (data?.cost_metrics?.customer_price !== null) {
			_state.customer_price.value = data?.cost_metrics?.customer_price
			_state.customer_price.dirty = true
		}

		if (data?.cost_metrics?.selling_price !== null) {
			_state.selling_price.value = data?.cost_metrics?.selling_price
			_state.selling_price.dirty = true
		}

		if (data?.cost_metrics?.quantity_discount_dn_cn !== null) {
			_state.quantity_discount_dn_cn.value = data?.cost_metrics?.quantity_discount_dn_cn
			_state.quantity_discount_dn_cn.dirty = true
		}

		if (data?.cost_metrics?.pricing_dn_cn !== null) {
			_state.pricing_dn_cn.value = data?.cost_metrics?.pricing_dn_cn
			_state.pricing_dn_cn.dirty = true
		}

		if (data?.cost_metrics?.warehousing_cost !== null) {
			_state.warehousing_cost.value = data?.cost_metrics?.warehousing_cost
			_state.warehousing_cost.dirty = true
		}

		if (data?.cost_metrics?.warehousing_provider !== null) {
			_state.warehousing_provider.value = data?.cost_metrics?.warehousing_provider
			_state.warehousing_provider.dirty = true
		}

		if (data?.cost_metrics?.cha_cost !== null) {
			_state.cha_cost.value = data?.cost_metrics?.cha_cost
			_state.cha_cost.dirty = true
		}

		if (data?.cost_metrics?.duty !== null) {
			_state.duty.value = data?.cost_metrics?.duty
			_state.duty.dirty = true
		}

		if (data?.cost_metrics?.cfs !== null) {
			_state.cfs.value = data?.cost_metrics?.cfs
			_state.cfs.dirty = true
		}

		if (data?.cost_metrics?.hedging_brokerage_cost !== null) {
			_state.hedging_brokerage_cost.value = data?.cost_metrics?.hedging_brokerage_cost
			_state.hedging_brokerage_cost.dirty = true
		}

		if (data?.cost_metrics?.hedging_profit_and_loss !== null) {
			_state.hedging_profit_and_loss.value = data?.cost_metrics?.hedging_profit_and_loss
			_state.hedging_profit_and_loss.dirty = true
		}

		if (data?.cost_metrics?.interest_deductions !== null) {
			_state.interest_deductions.value = data?.cost_metrics?.interest_deductions
			_state.interest_deductions.dirty = true
		}
	} else if (data?.other_charges && data?.enquiry_id) {
		// set freight charges from other charges if freight charges is present in enquiry
		let _freight = data?.other_charges?.find((item) => item.product_id === 'freight_charges')
		if (_freight?.rate_per_mt) {
			_state.freight_per_mt.value = _freight?.rate_per_mt
		} else {
			let _weight = data?.final_quote_buyer?.quote_per_product?.reduce((acc, item) => item?.serviceable_weight + acc, 0) / 1000
			_state.freight_per_mt.value = (_freight?.rate_lumpsum / _weight).toFixed(2)
		}
	}

	return _state
}
